import { useNavigate } from "react-router-dom";
import { T } from "../theme";

/**
 * UserLink — the one true way to render a username.
 *
 *   <UserLink username="devin" userId="abc123" />
 *
 * Renders a neon-tinted tappable username that navigates to /user/:username.
 * Never render plain-text usernames — always wrap them in this so every
 * mention is a door to that raver's stage.
 *
 * `disabled` renders the plain (non-tappable) form — used when the backend
 * says the owner's profile is not linkable for this viewer.
 */

function UserLink({ username, userId, disabled = false, style }) {
  const navigate = useNavigate();
  if (!username) return null;

  if (disabled) {
    return (
      <span style={{ fontWeight: 700, color: T.textStrong, ...style }}>
        {username}
      </span>
    );
  }

  return (
    <span
      className="user-link"
      role="link"
      tabIndex={0}
      data-user-id={userId || undefined}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/user/${encodeURIComponent(username)}`);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          navigate(`/user/${encodeURIComponent(username)}`);
        }
      }}
      style={{
        fontWeight: 700,
        color: T.cyan,
        cursor: "pointer",
        textShadow: `0 0 6px ${T.cyan}33`,
        transition: "text-shadow 0.15s, color 0.15s",
        touchAction: "manipulation",
        ...style,
      }}
    >
      {username}
    </span>
  );
}

export default UserLink;
